<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >     
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="巡演ID">
                        <el-input v-model="formData.id" placeholder="请输入巡演ID" maxlength="80" readonly size="medium"/>
                    </el-form-item>
                </el-col>  
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="巡演名称">
                        <el-input v-model="formData.name" placeholder="请输入巡演名称" size="medium" maxlength="100"/>
                    </el-form-item>
                </el-col>
            </el-row> 
            <el-form-item prop="goodsType" label="绑定演出">
                <div class="page-list-box">
                    <el-table
                        :data="dataList"
                        border
                        style="width: 100%"
                        size="small"
                        stripe
                    >
                        <el-table-column label="城市" prop="cityName"></el-table-column>
                        <el-table-column label="演出ID" prop="id" ></el-table-column>
                        <el-table-column label="演出名称" min-width="180" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span class="ellipsis">{{ scope.row.titleStr ||  scope.row.title}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="场地" prop="siteName" min-width="150" show-overflow-tooltip></el-table-column> 
                        <el-table-column label="首场次开演时间" prop="beginShowTime" min-width="140"></el-table-column>                 
                        <el-table-column label="艺人阵容" prop="performer" min-width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed="right" label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    v-if="$utils.have('/theme/manger/unBinding')"
                                    icon="el-icon-s-management"
                                    @click="unBinding(scope.row.id)"
                                    >解绑</el-button>
								
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="data" class="page-pagination-box">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="getData"
                        :current-page.sync="params.pageNo"
                        :page-sizes="$pageSizes"
                        :page-size.sync="params.pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="data.totalCount || 0"
                    >
                    </el-pagination>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">返回</el-button>
                <el-button @click="onSubmit" :loading="btnLoading" type="primary" v-if="$utils.have('/theme/manger/save')">保存</el-button>
                <el-button type="warning" @click="toActivityList" v-if="$utils.have('/activity/list')">在演出列表查看所有演出</el-button>
                <el-button type="danger" @click="delShow" v-if="$utils.have('/theme/manger/delete')">删除</el-button>
            </el-form-item>
        </el-form>
		
    </div>
</template>

<script>

export default {
	
    props: {
        id: {
        type: [Number, String],
        default: null,
        },
    },
    data() {
        return {
            formData: {
                id: '',
                name: ''
            },
            params: {
                pageNo: 1, 
                pageSize: this.$pageSizes[0]
            },
            data: null,
            dataList: null,
            rules: {
                name: [{ required: true, message: "请输入巡演名称" }]
            },
            pageLoading: false,
            btnLoading: false,
            redirect: this.$route.query.redirect || '',
        };
    },
    created() {
        if (this.id) {
            this.getData();
        }
    },
    methods: {
        // 获取详情
        getData() {
            this.pageLoading = true;
            const data = {...this.params, id: this.id}
            this.$request({
                url: "/tour/manger/detail",
                method: "POST",
                data
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        this.formData.id = result.id;
                        this.formData.name =  result.name;
                        if(result.activityListVOPage){
                            const {total, size, current, records} = result.activityListVOPage;
                            records.forEach(item=> {								
                                if(item.title && item.title.length>40){
                                    item.titleStr = item.title.slice(0,40) + '...'
                                }
                            })
                            this.dataList = records;
                            this.data = {
                                totalCount: total,
                                pageNo: current,
                                pageSize: size
                            }
                        }
                    } else {
                        return this.$message.error(msg || "获取详情失败");
                    }
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getData();
        },
		
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const data = { ...this.formData };
                    this.$request({
                        url: '/tour/manger/save',
                        method: "POST",
                        data,
                    })
                        .then((res) => {
                        //处理成功回调
                        const { state, msg } = res.data;
                        if (state && state == 1) {
                            this.$message.success("保存成功");
                            this.$router.go(-1);
                        } else {
                            return this.$message.error(msg || "操作失败");
                        }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        // 解绑
        unBinding(id){
            this.$confirm('确认解绑吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(()=> {
                this.$request({
                    url: "/tour/manger/unBinding",
                    method: "POST",
                    params:{ activityId: id, tourId: this.id }
                }).then(res=> {
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        this.$message.success("解绑成功");
                        this.getData();
                    } else {
                        return this.$message.error(msg || "解绑失败");
                    }
                })
            }).catch(()=> {})          
        },
        // 删除
        delShow(){
            this.$confirm('删除后所有演出将自动从巡演中解绑,是否确定删除该巡演?', '提示', {
                confirmButtonText: '确认删除',
                cancelButtonText: '暂不删除',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(()=> {
                this.$request({
                    url: "/tour/manger/delete",
                    method: "POST",
                    params:{
                        tourId: this.id
                    }
                }).then(res=> {
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        this.$message.success("删除成功");
                        this.$router.go(-1);
                    } else {
                        return this.$message.error(msg || "删除失败");
                    }
                })
            }).catch(()=> {}) 
        },
        toActivityList(){
            this.$router.push({path: '/activityManage/activity/list', query: {searchType: 3, searchValue: this.id}})
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    },
};
</script>
